import React, { Component } from "react";
import Sticky from "react-sticky-el";
import { Container } from "semantic-ui-react";
import CategoryPage from "./components/CategoryPage/CategoryPage";
// import TestPage from "./components/TestPage/TestPage";
import NewTestPage from "./components/TestPage/NewTestPage";
import ExperimentPage from "./components/ExperimentPage/ExperiemntPage";
import LandingPage from "./components/LandingPage/LandingPage";
import SettingsPage from "./components/SettingsPage/SettingsPage";
import CategoryTestsPage from "./components/CategoryTestsPage/CategoryTestsPage";
import UserDetailedPage from "./components/UserDetail/UserDetailedPage";
import TestDetailPage from "./components/TestDetailPage/TestDetailPage";
import NotFoundPage from "./components/NotFoundPage/NotFound";
import { Switch, Route } from "react-router-dom";
import Navbar from "./components/Nav/Navbar/Navbar";
// import NewNavbar from "./components/Nav/Navbar/NewNavbar";
import ModalManager from "./features/modals/ModalManager";
import BurgerNavbar from "./components/Nav/Navbar/BurgerNavbar";
import { connect } from "react-redux";
import { withFirebase } from "react-redux-firebase";
import { withRouter } from "react-router-dom";
import { openModal } from "../src/features/modals/modalActions";
import SignedInMenu from "./components/Nav/Menus/SignedInMenu";
import SignedOutMenu from "./components/Nav/Menus/SignedOutMenu";

const actions = {
    openModal
};

const mapState = state => ({
    auth: state.firebase.auth,
    profile: state.firebase.profile
});

class App extends Component {
    state = {
        windowHeight: undefined,
        windowWidth: undefined
    };

    handleResize = () =>
        this.setState({
            windowHeight: window.innerHeight,
            windowWidth: window.innerWidth
        });

    componentDidMount() {
        this.handleResize();
        window.addEventListener("resize", this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    handleSignIn = () => {
        this.props.openModal("LoginModal");
    };

    handleRegister = () => {
        this.props.openModal("RegisterModal");
    };

    handleSignOut = () => {
        this.props.firebase.logout();
        this.props.history.push("/");
    };

    render() {
        const { auth, profile } = this.props;
        const authenticated = auth.isLoaded && !auth.isEmpty;
        return (
            <div>
                <ModalManager />

                <Switch>
                    <Route exact path="/" component={LandingPage} />
                </Switch>

                <Route
                    path="/(.+)"
                    render={() => (
                        <div>
                            {this.state.windowWidth < 750 ? (
                                <div>
                                    <Sticky
                                        style={{
                                            zIndex: 200
                                        }}
                                    >
                                        <div
                                            style={{
                                                height: 50,
                                                background: "black"
                                            }}
                                        >
                                            <div
                                                style={{
                                                    float: "right",
                                                    display: "flex",
                                                    marginTop: "7px"
                                                }}
                                            >
                                                {authenticated ? null : (
                                                    <SignedOutMenu
                                                        signIn={
                                                            this.handleSignIn
                                                        }
                                                        register={
                                                            this.handleRegister
                                                        }
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </Sticky>
                                    <BurgerNavbar />
                                </div>
                            ) : (
                                <Navbar />
                            )}

                            {/* <NewNavbar /> */}
                            <div>
                                <Container className="main">
                                    <Switch>
                                        <Route
                                            path="/category"
                                            component={CategoryPage}
                                        />
                                        <Route
                                            path="/experiment"
                                            component={ExperimentPage}
                                        />
                                        <Route
                                            path="/test"
                                            component={NewTestPage}
                                        />
                                        <Route
                                            path="/settings"
                                            component={SettingsPage}
                                        />
                                        <Route
                                            path="/profile/:id"
                                            component={UserDetailedPage}
                                        />
                                        <Route
                                            path="/categoryTestPage"
                                            component={CategoryTestsPage}
                                        />
                                        <Route
                                            path="/testDetailPage"
                                            component={TestDetailPage}
                                        />
                                        <Route
                                            path="/error"
                                            component={NotFoundPage}
                                        />
                                    </Switch>
                                </Container>
                            </div>
                        </div>
                    )}
                />
            </div>
        );
    }
}

// export default App;

export default withRouter(
    withFirebase(
        connect(
            mapState,
            actions
        )(App)
    )
);
